// react
import React from 'react';
// third-party
import PropTypes from 'prop-types';
function PageHeader(props) {
    let { header, breadcrumb = [] } = props;

    if (header) {
        header = (
            <div className="page-header__title">
                <h1>{header}</h1>
            </div>
        );
    }

    if (breadcrumb.length > 0) {
        breadcrumb = breadcrumb.map((item, index) => {
            let link;

            
            link = <li key={index} className="breadcrumb-item active" aria-current="page">{item.title}</li>;
            
            return link;
        });

        breadcrumb = (
            <div className="page-header__breadcrumb">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        {breadcrumb}
                    </ol>
                </nav>
            </div>
        );
    }

    return (
        <div className="page-header">
            <div className="page-header__container container">
                {breadcrumb}
                {header}
            </div>
        </div>
    );
}

PageHeader.propTypes = {
    /** page header */
    header: PropTypes.node,
    /** array of breadcrumb links */
    breadcrumb: PropTypes.array,
};

export default PageHeader;
